import { render } from "./MoveFilePopup.vue?vue&type=template&id=49304f08"
import script from "./MoveFilePopup.vue?vue&type=script&lang=js"
export * from "./MoveFilePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__